import { DateUtil } from '@src/packages/utils/dates';

const DATE_FORMAT = DateUtil.DEFAULT_DT_DATE_FORMAT;

/**
 * Builds the period description text shown in EmptyUserData exports and UI.
 * @param {Object} intl - react-intl intl instance
 * @param {string|null} startDate - Query param startDate
 * @param {string|null} endDate - Query param endDate
 * @param {string} [queriedPeriod=''] - Pre-formatted period from useReportManagerDt
 * @returns {string}
 */
export const getPeriodEmptyUserDataText = (intl, startDate, endDate, queriedPeriod = '') => {
  if (queriedPeriod) {
    return queriedPeriod;
  }

  if (startDate === 'null' || startDate === null) {
    return intl.formatMessage({ id: 'timeTracker.reports.emptyUserData.noPeriodDescription' });
  }

  const endDateValue = endDate !== 'null' && endDate !== null ? Number(endDate) : Date.now();

  return intl.formatMessage(
    { id: 'timeTracker.reports.emptyUserData.periodDescription' },
    {
      startDate: DateUtil.toDateString(Number(startDate), DATE_FORMAT),
      endDate: DateUtil.toDateString(endDateValue, DATE_FORMAT),
    },
  );
};
